import React from "react";

import { Organisation, User } from "../../../types";
import CardsViewShell from "../../../components/views/cards-view-shell";
import TeamCard from "./team-card";

interface TeamsCardsViewProps {
  filteredTeams: Organisation[];
  unfilteredTeamsCount: number;
  users: Record<string, User>;
  canEditOrgs: string[];
}

const TeamsCardsView: React.FC<TeamsCardsViewProps> = ({
  filteredTeams,
  users,
  unfilteredTeamsCount,
  canEditOrgs,
}) => {
  return (
    <CardsViewShell shownCount={filteredTeams.length} totalCount={unfilteredTeamsCount}>
      {filteredTeams.map((team) => (
        <TeamCard
          key={team.organisationId}
          team={team}
          users={users}
          showManageButton={canEditOrgs.includes(team.organisationId)}
        />
      ))}
    </CardsViewShell>
  );
};

export default TeamsCardsView;

